export const ENTRYPOINT = 'https://api.phpmysql.com.br';
// export const ENTRYPOINT = 'http://localhost';